import React, { useEffect, useState, useCallback } from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from './SignatureDetails.module.css';
import { formatDateFromDB } from '../../../util/functions'
import { useTranslation } from "react-i18next";
import { getSignatureDetailsById } from '../../../axios/requests/signatureReq'

const SignatureDetails = ({ onHide, onSignatureDocAttachClicked, _id, fileName, createdAt, fileUrl, clientName, contactName, msgType }) => {
    const [t] = useTranslation('common')
    const [signatureDetailsState, setSignatureDetailsState] = useState()

    useEffect(() => {
        const getSignatureDetails = async () => {
            const signatureDetails = await getSignatureDetailsById(_id)
            signatureDetails.signatureDataFields.forEach((field) => {
                if (field._id === 'ds_recipient_first_name') {
                    field.value = contactName
                }
                else if (field._id === 'ds_recipient_full_name') {
                    field.value = contactName
                }
                else if (field._id === 'ds_recipient_phone' && (msgType === 'whatsapp' || msgType === 'sms')) {
                    field.value = clientName.replace('+972', '0')
                }
                else if (field._id === 'ds_recipient_email' && msgType === 'mail') {
                    field.value = clientName
                }
            })
            setSignatureDetailsState(signatureDetails)
        }
        getSignatureDetails()
    }, [_id, clientName, contactName])

    const onInputChange = useCallback((event, fieldId) => {
        const newInputValue = event.target.value
        setSignatureDetailsState((oldSignDetails) => {
            return {
                ...oldSignDetails,
                signatureDataFields: oldSignDetails.signatureDataFields.map((field) => {
                    if (field._id === fieldId) {
                        return {
                            ...field,
                            value: newInputValue
                        }
                    }
                    else {
                        return field
                    }
                })
            }
        })
    }, [])

    let fieldElements
    if (signatureDetailsState) {
        fieldElements = signatureDetailsState.signatureDataFields.map((field) => {
            return <div className={styles['field-container']}>
                <label>{field.label}</label>
                <input placeholder={field.placeholder} type='text' value={field.value} onChange={(e) => onInputChange(e, field._id)} />
            </div>
        })
    }

    const onSignatureDocAttachClickedHandler = useCallback(() => {
        onSignatureDocAttachClicked(signatureDetailsState)
    }, [signatureDetailsState])

    return (
        <Modal show={true} onHide={onHide} dialogClassName={`${styles['preview-modal']}`} size="lg" centered aria-labelledby="contained-modal-title-vcenter" className='rtl-modal' >
            <Modal.Header>
                <Modal.Title className={styles['modal-title']}>
                    <div className={styles['file-header-container']}>
                        <h3 className={styles['file-name']}>{fileName}</h3>
                        <time className={styles['file-date']}>{formatDateFromDB(createdAt)}</time>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={`preview-modal-body ${styles['preview-modal-body']}`}>
                {signatureDetailsState && <section className={styles['signature-section']}>
                    <div className={styles['doc-fields-container']}>
                        {fieldElements}
                    </div>
                    <img src={fileUrl} className={styles['doc-image']} alt='Document image' />
                </section>}
            </Modal.Body>
            <Modal.Footer className={styles['modal-footer']}>
                <Button disabled={!signatureDetailsState} onClick={onSignatureDocAttachClickedHandler} type='submit' form="contactForm" variant="primary" className='btn-success'>{t('attach')}</Button>
                <Button variant="secondary" onClick={onHide}>{t('Exit')}</Button>
            </Modal.Footer>
        </Modal>
    )

}

export default SignatureDetails;